module.exports = __webpack_public_path__ + "static/media/af-min.14711a06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/af-min.svg
// module id = 685
// module chunks = 0